import {
    SITEIDS_FAILURE,
    SITEIDS_LOADING,
    SITEIDS_SUCCESS,
    CATEGORIES_LOADING,
    CATEGORIES_FAILURE,
    CATEGORIES_SUCCESS,
    ADMIN_SITES_FAILURE,
    ADMIN_SITES_LOADING,
    ADMIN_SITES_SUCCESS,
    SET_MOBILE,
} from 'redux/reduxConstants';

const siteState = {
    siteIds: [],
    adminSiteIds: [],
    adminSiteIdsLoading: false,
    siteIdsLoading: false,
    categories: [],
    categoriesLoading: false,
    showMobile: false,
    error: '',
};

const site = (state = siteState, action) => {
    switch (action.type) {
        case SITEIDS_SUCCESS:
            const siteIdsSuccessState = { ...state };
            siteIdsSuccessState.siteIds = action.siteIds;
            siteIdsSuccessState.siteIdsLoading = false;

            return siteIdsSuccessState;
        case SITEIDS_LOADING:
            const siteIdsLoadingState = { ...state };
            siteIdsLoadingState.siteIdsLoading = true;

            return siteIdsLoadingState;
        case SITEIDS_FAILURE:
            const siteIdsFailureState = { ...state };
            siteIdsFailureState.siteIdsLoading = false;
            siteIdsFailureState.error = action.error;

            return siteIdsFailureState;
        case CATEGORIES_SUCCESS:
            const categoriesSuccessState = { ...state };
            categoriesSuccessState.categories = action.categories;
            categoriesSuccessState.categoriesLoading = false;

            return categoriesSuccessState;
        case CATEGORIES_LOADING:
            const categoriesLoadingState = { ...state };
            categoriesLoadingState.categoriesLoading = true;

            return categoriesLoadingState;
        case CATEGORIES_FAILURE:
            const categoriesFailureState = { ...state };
            categoriesFailureState.categoriesLoading = false;
            categoriesFailureState.error = action.error;

            return categoriesFailureState;
        case ADMIN_SITES_SUCCESS:
            const adminSitesSuccessState = { ...state };
            adminSitesSuccessState.adminSiteIds = action.adminSiteIds;
            adminSitesSuccessState.adminSiteIdsLoading = false;

            return adminSitesSuccessState;
        case ADMIN_SITES_LOADING:
            const adminSitesLoadingState = { ...state };
            adminSitesLoadingState.adminSiteIdsLoading = true;

            return adminSitesLoadingState;
        case ADMIN_SITES_FAILURE:
            const adminSitesFailureState = { ...state };
            adminSitesFailureState.adminSiteIdsLoading = false;
            adminSitesFailureState.error = action.error;

            return adminSitesFailureState;
        case SET_MOBILE:
            const setMobileState = { ...state };
            setMobileState.showMobile = action.showMobile;

            return setMobileState;
        default:
            return state;
    }
};

export default site;
